import React, { FC } from 'react'

export const Aggregator:FC = () => {
  return (
    <>
       <h2>Agg</h2> 
    </>
  )
}


